export default __webpack_public_path__ + "static/media/hht2_sitcom_19.680ed75e.png";